
export const actionTypes = {
  Login: "[Login] Action",
  LoginError: "[Login Error] Action",
  loginErrorDone: "[login Error Done Error] Action",
  Logout: "[Logout] Action",
  Register: "[Register] Action",
  UserRequested: "[Request User] Action",
  UserLoaded: "[Load User] Auth API",
  SetUser: "[Set User] Action",
  GetCaptcha : "[Get Captcha] Action",
  loadCaptchaImage: "[Load Captcha Image] Action",
  loadCaptchaImageSuccess: "[Load Captcha Image Success] Action",
};

//dispatch actions
export const actions = {
  loadCaptchaImage:()=>({
    type: actionTypes.loadCaptchaImage,
  }),
  loadCaptchaImageSuccess:(data)=>({
    type: actionTypes.loadCaptchaImageSuccess,
    payload: { data },
  }),

  // 登入
  login: (authToken) => ({
    type: actionTypes.Login,
    payload: { authToken }
  }),
  // 登入失敗
  loginError:()=>({
    type: actionTypes.LoginError,
  }),
  // 處理登入失敗
  loginErrorDone:()=>({
    type: actionTypes.loginErrorDone,
  }),
  
  // 和後端要求User資料
  requestUser: (authToken) => ({
    type: actionTypes.UserRequested,
    paload: {authToken}
  }),
  // 把User資料透過action發給reducer
  fulfillUser: (user) => ({
    type: actionTypes.UserLoaded,
    payload: { user }
  }),
  setUser: (user) => ({
    type: actionTypes.SetUser,
    payload: { user }
  }),

  
  register: (authToken) => ({
    type: actionTypes.Register,
    payload: { authToken },
  }),
  logout: () => ({
    type: actionTypes.Logout
  }),

};

